import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Icon from './icon'
import Text from './text'

class StatusPrepend extends ImmutablePureComponent {

  render() {
    const {
      status,
      isFeatured,
      isPromoted,
      isComment,
      isPinnedInGroup,
      onOpenProModal,
    } = this.props

    if (!status) return null

    const isRepost = (status.get('reblog', null) !== null && typeof status.get('reblog') === 'object')
    const showRepostedComment = !!status.getIn(['reblog', 'in_reply_to_account_id'], null) && isRepost
    const reblogUrl = status.getIn(['reblog', 'url'], null)
    const isOrphaned = status.get('is_reply', false) && !status.get('in_reply_to_id', null)
    
    if (!isFeatured && !isPinnedInGroup && !isPromoted && !isRepost && !isComment && !isOrphaned) return null

    let iconId
    if (isFeatured || isPinnedInGroup) iconId = 'pin'
    else if (isPromoted) iconId = 'star'
    else if (isRepost) iconId = 'repost'
    else if (isComment) iconId = 'comment'

    return (
      <div className={[_s.d, _s.w100PC, _s.flexRow, _s.aiStart, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
        <div className={[_s.d, _s.flexNormal, _s.flexRow, _s.aiCenter, _s.py5, _s.px15, _s.overflowHidden].join(' ')}>
          <Icon id={iconId} size='12px' className={[_s.cSecondary, _s.mr5].join(' ')} />
          {
            isRepost && !isComment && !showRepostedComment &&
            <div className={[_s.d, _s.flexRow].join(' ')}>
              <Text size='small' color='secondary'>
                <NavLink
                  className={[_s.noUnderline, _s.underline_onHover].join(' ')}
                  to={`/${status.getIn(['account', 'acct'])}`}
                >
                  <Text size='small' color='secondary'>
                    <bdi>
                      <span dangerouslySetInnerHTML={{ __html: status.getIn(['account', 'display_name_html']) }} />
                    </bdi>
                  </Text>
                </NavLink>
                &nbsp;reposted
              </Text>
            </div>
          }
          {
            isRepost && !isComment && showRepostedComment &&
            <div className={[_s.d, _s.flexRow].join(' ')}>
              <Text size='small' color='secondary'>
                <NavLink
                  className={[_s.noUnderline, _s.underline_onHover].join(' ')}
                  to={`/${status.getIn(['account', 'acct'])}`}
                >
                  <Text size='small' color='secondary' weight='medium'>
                    <bdi>
                      <span dangerouslySetInnerHTML={{ __html: status.getIn(['account', 'display_name_html']) }} />
                    </bdi>
                  </Text>
                </NavLink>
                
                &nbsp;reposted a&nbsp;
                
                <a
                  className={[_s.noUnderline, _s.cSecondary, _s.underline_onHover].join(' ')}
                  href={reblogUrl}
                >
                  <Text size='small' color='secondary' weight='medium'>
                    comment
                  </Text>
                </a>

                &nbsp;on&nbsp;

                <a
                  className={[_s.noUnderline, _s.cSecondary, _s.underline_onHover].join(' ')}
                  href={reblogUrl}
                >
                  <Text size='small' color='secondary' weight='medium'>
                    a post
                  </Text>
                </a>
              </Text>
            </div>
          }
          {
            !isRepost && isFeatured &&
            <Text color='secondary' size='small'>
              {isFeatured ? 'Pinned gab' : isPinnedInGroup ? 'Pinned to group' : 'Promoted gab'}
            </Text>
          }
          {
            isComment && !isFeatured &&
            <Text color='secondary' size='small'>
              <NavLink
                className={[_s.noUnderline, _s.underline_onHover].join(' ')}
                to={`/${status.getIn(['account', 'acct'])}`}
              >
                <Text size='small' color='secondary' weight='medium'>
                  <bdi>
                    <span dangerouslySetInnerHTML={{ __html: status.getIn(['account', 'display_name_html']) }} />
                  </bdi>
                </Text>
              </NavLink>
              &nbsp;commented on this gab
            </Text>
          }
          {
            isOrphaned && !isFeatured &&
            <Text color='secondary' size='small'>
              This was a reply to a status which is no longer available
            </Text>
          }          
        </div>
        {
          isPromoted &&
          <div className={[_s.d, _s.h100PC, _s.pr10, _s.py2, _s.aiCenter, _s.jcCenter].join(' ')}>
            <button
              className={[_s.d, _s.cursorPointer, _s.outlineNone, _s.bgTertiary, _s.circle, _s.py2, _s.px5].join(' ')}
              onClick={onOpenProModal}
            >
              <Text color='tertiary' size='extraSmall' isBadge>
                ?
              </Text>
            </button>
          </div>
        }
      </div>
    )
  }

}

StatusPrepend.propTypes = {
  status: ImmutablePropTypes.map,
  isComment: PropTypes.bool,
  isFeatured: PropTypes.bool,
  isPinnedInGroup: PropTypes.bool,
  isPromoted: PropTypes.bool,
  onOpenProModal: PropTypes.func,
}

export default StatusPrepend